import {
  useMutation,
  useQueryClient,
  type QueryKey,
  type UseMutationResult,
} from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { invalidateQueryKeys } from './invalidateQueryKeys'

interface DenyLocationRequestData {
  sweepstakeDrawingId: number
}

interface UseDenyLocationRequestProps {
  onSuccess?: (data: undefined, variables: DenyLocationRequestData) => void
  onError?: (error: Error, variables: DenyLocationRequestData) => void
  invalidateQueryKeys?: readonly QueryKey[]
}

export const useDenyLocationRedrawRequest = ({
  onSuccess,
  onError,
  invalidateQueryKeys: queryKeysToInvalidate,
}: UseDenyLocationRequestProps): UseMutationResult<
  any,
  Error,
  DenyLocationRequestData
> => {
  const redrawWinner = useTypedApiClient({
    path: '/admin/sweepstake-winners/denyLocationRedrawRequest/{sweepstakeDrawingId}',
    method: 'put',
  })

  const queryClient = useQueryClient()

  return useMutation<any, Error, DenyLocationRequestData>({
    mutationFn: async ({ sweepstakeDrawingId }: DenyLocationRequestData) => {
      const response = await redrawWinner({
        sweepstakeDrawingId,
      })
      return response.data
    },
    onSuccess: async (data, variables) => {
      if (
        queryKeysToInvalidate !== undefined &&
        queryKeysToInvalidate.length > 0
      ) {
        await invalidateQueryKeys(queryClient, queryKeysToInvalidate)
      } else {
        await queryClient.invalidateQueries({
          queryKey: ['/sweepstakes'],
        })
      }

      onSuccess?.(data, variables)
    },
    onError,
  })
}
